import React from "react";

import { useIntl } from "react-intl";

import { Modal } from "@mapmycustomers/ui";

interface Props {
  onClose: () => void;
}

const StepInfo: React.FC<Props> = ({ onClose }) => {
  const intl = useIntl();
  return (
    <Modal
      cancelButtonProps={{ hidden: true }}
      maskClosable={false}
      okText={intl.formatMessage({
        id: "settings.newImports.header.step.matchFields.modal.okText",
        defaultMessage: "Ok",
        description: "Step Info modal - Ok button text",
      })}
      onCancel={onClose}
      onOk={onClose}
      title={intl.formatMessage({
        id: "settings.newImports.header.step.matchFields.modal.title",
        defaultMessage: "We mapped some fields based on their names.",
        description: "Steps Info modal title",
      })}
      visible
    >
      <div>
        <p>
          {intl.formatMessage({
            id: "settings.newImports.header.step.matchFields.modal.content",
            defaultMessage:
              "Please review each field—if it’s not yet (or incorrectly) matched, you can use the dropdown to select another field.",
            description: "Steps Info modal content",
          })}
        </p>
        <p>
          {intl.formatMessage({
            id: "settings.newImports.header.step.matchFields.modal.subContent",
            defaultMessage:
              "Alternatively, click “Create a new custom field” to create a new text field using the header from the file. If there is a column you would not like to import, select “Skip” from the dropdown.",
            description: "Steps Info modal subcontent",
          })}
        </p>
      </div>
    </Modal>
  );
};

export default StepInfo;
